/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var input = new Class({
  Implements: [IO],
  options: {
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
  },
  renderAnswer: 'default',
  initialize: function (data, input, answerCallback, errorCallback, validateAnswerCallback) {
    this.data = data
    this.type = this.data.type.name
    this.input = input
    this.answerCallback = answerCallback
    this.errorCallback = errorCallback
    this.validateAnswerCallback = validateAnswerCallback

    this.element = this.input.getParents('.input--wrapper')[0]
    this.button = this.element.getElements('.input--button')[0]

    this.parent = $('conversation')
    this.parent_after = $('after')

    this.createPseudo()
    this.events()
  },
  createPseudo: function () {
    var self = this.input
    var pseudo = new Element('div', {
      id: 'textPseudo',
      styles: {
        position: 'absolute',
        left: -1000000,
        top: -1000000,
        width: self.getSize().x,
        'min-height': self.getSize().y,
        'box-sizing': self.getStyle('box-sizing'),
        border: self.getStyle('border'),
        'line-height': self.getStyle('line-height'),
        'font-size': self.getStyle('font-size'),
        'font-weight': self.getStyle('font-weight'),
        'font-family': self.getStyle('font-family'),
        padding: self.getStyle('padding'),
        'word-break': self.getStyle('word-break'),
        'overflow-wrap': self.getStyle('overflow-wrap'),
        hyphens: self.getStyle('hyphens'),
        'max-height': 220,
        visibility: 'hidden',
        overflow: 'hidden',
        opacity: 0,
      },
    })
    pseudo.inject(document.body)
    this.pseudo = $('textPseudo')
  },
  events: function () {
    //onload
    if (this.input.get('value') != '') {
      this.content = this.input.get('value').replace(/\n/g, '<br/>')
      this.pseudo.set('html', this.content + '...')
      this.update()
    }

    //other events;
    this.input.addEvents({
      keyup: function (e) {
        this.content = this.input.get('value').replace(/\n/g, '<br/>')
        this.pseudo.set('html', this.content + '...')
        if (this.input.get('value').length == 0) {
          this.element.removeClass('hasError')
        }
        this.update()
      }.bind(this),
    })

    this.button.addEvents({
      click: function () {
        this.send()
      }.bind(this),
    })

    if (!BrowserData.isMobile) {
      if (!this.data.accessibilityMode) {
        this.input.focus()
      }
      var oldValue = this.input.value
      this.input.value = ''
      this.input.value = oldValue
    }

    this.inputEvents()
  },
  update: function () {
    if (this.pseudo) {
      this.input.setStyles({ height: this.pseudo.getSize().y })
    }
  },
  discard: function () {
    this.out(this.pseudo)
  },
  gather: function (breaks) {
    var res
    if (breaks) {
      res = this.input.get('value').replace(/\n/g, '<br/>').clean()
    } else {
      res = this.input.get('value').clean()
    }
    if (res && res.normalize) {
      res = res.normalize('NFKC')
    }
    return res
  },
  check: function (value) {
    var AnswerValue = value || this.gather().clean()

    switch (this.type) {
      case 'number':
        var min_value = parseFloat(this.data.meta.min_value, 10),
          max_value = parseFloat(this.data.meta.max_value, 10)

        if (!isNaN(min_value) || !isNaN(max_value)) {
          AnswerValue = parseFloat(AnswerValue, 10)
          if (AnswerValue < min_value || AnswerValue > max_value) {
            return false
          }
        }
        return true
      case 'time':
        var min_value = this.input.get('min'),
          max_value = this.input.get('max')
        if (this.input.validity && !this.input.validity.valid) {
          return false
        }
        if (
          (typeof min_value === 'string' && AnswerValue < min_value) ||
          (typeof max_value === 'string' && AnswerValue > max_value)
        ) {
          return false
        }
        return true
      case 'phone':
        return validator.isMobilePhone(AnswerValue, 'any')
      case 'email':
        return validator.isEmail(AnswerValue)
      case 'iban':
        return IBAN.isValid(AnswerValue)
      case 'nickname':
        return new RegExp(/(^[\d\w]+$)/g).test(AnswerValue)
      case 'name':
      case 'first_name':
      case 'last_name':
        return XRegExp("^[\\pL'-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\\]]{1,}$").test(AnswerValue)
      default:
        if (this.data.meta.regexp) {
          var reg = new RegExp(this.data.meta.regexp)
          return reg.test(AnswerValue)
        }
        return true
    }
  },
  send: function () {
    if (this.button.hasClass('disallowed')) {
      return
    }
    var cleanValue = this.gather().clean()
    var sendAnswer = function () {
      this.element.blur()
      var answerData = {
        answer: {
          render: this.renderAnswer,
          value: cleanValue,
          content: this.gather(true),
        },
      }
      this.out()
      this.answerCallback(this.data, answerData)
    }.bind(this)

    if (!cleanValue) {
      if (typeof this.data.is_required === 'undefined' || this.data.is_required) {
        this.errorCallback(this.data, this.type, 'missing')
      } else {
        sendAnswer()
      }
    } else if (this.check()) {
      if (this.data.meta && this.data.meta.validateScript) {
        this.element.addClass('withSpinner')
        try {
          this.validateAnswerCallback(
            this.data.meta.validateScript,
            cleanValue,
            function (result) {
              this.element.removeClass('withSpinner')
              if (result) {
                this.errorCallback(this.data, this.type, 'invalid', result)
              } else {
                sendAnswer()
              }
            }.bind(this)
          )
        } catch (e) {
          this.element.removeClass('withSpinner')
          throw e
        }
      } else {
        sendAnswer()
      }
    } else {
      this.errorCallback(this.data, this.type, 'invalid')
    }
  },
  /**
   * validators
   * @type {Object}
   */
  validators: function () {
    return {
      /**
       * maxLength
       * @method maxLength
       * @return {null}
       */
      maxLength: function (maxLengh) {
        var maxLength = parseInt(this.data.meta.max_length, 10) || maxLengh

        if (maxLength) {
          this.input.addEvents({
            keydown: function (e) {
              if (this.options.exceptions.indexOf(e.key.toString()) === -1 && this.input.value.length + 1 > maxLength) {
                if (this.input.getSelectedText().length === 0) {
                  e.preventDefault()
                  return
                }
              }
            }.bind(this),
          })
        }
      }.bind(this),

      /**
       * validate minLength
       * @method minLength
       * @return {null}
       */
      minLength: function () {
        var minChars = parseInt(this.data.meta.minChars, 10) || parseInt(this.data.meta.min_length, 10)

        /**
         * update remaining
         * @method updateRemaining
         * @param  {number}        minChars
         * @return {null}
         */
        function updateRemaining(minChars, input, button) {
          var remaining = minChars - parseInt(input.value.length, 10)
          if (button.parentNode && button.childNodes.length === 0) {
            button.insertAdjacentHTML('beforeend', '<div class="button--countdown">' + remaining + '</div>')
          } else {
            button.childNodes[0].innerHTML = remaining
          }

          button.classList.toggle('disallowed', remaining > 0)
        }

        if (minChars) {
          updateRemaining(minChars, this.input, this.button)

          this.input.addEvents({
            keyup: function (e) {
              updateRemaining(minChars, this.input, this.button)
            }.bind(this),
          })
        }
      }.bind(this),
    }
  },
})

var input_long = new Class({
  Extends: input,
  options: {
    disallowed: ['enter'],
  },
  inputEvents: function () {
    var validators = this.validators()
    var allowNewLine = typeof this.data.meta.allowNewLine === 'boolean' ? this.data.meta.allowNewLine : true
    var submitByEnter = this.data.meta.submitByEnter
    if (submitByEnter) {
      allowNewLine = false
    }
    validators.minLength()
    validators.maxLength()

    this.input.addEvents({
      keydown: function (e) {
        if (this.options.disallowed.indexOf(e.key) >= 0 && !e.shift) {
          if (e.key == 'enter' && allowNewLine || event.shiftKey) {
            return
          }
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key) >= 0 && !e.shift) {
          if (e.key == 'enter') {
            if (!allowNewLine) {
              this.send()
            }
            return
          }
          e.preventDefault()
          return
        }
      }.bind(this),
    })
  },
})

var input_short = new Class({
  Extends: input,
  options: {
    maxLengh: 50,
    exceptions: ['backspace', 'up', 'down', 'left', 'right', 'enter'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    var validators = this.validators()

    validators.minLength()
    var maxLengh =
      parseInt(this.data.meta.maxChars, 10) || parseInt(this.data.meta.max_length, 10) || this.options.maxLengh
    validators.maxLength(maxLengh)

    this.element.addEvents({
      keydown: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
      }.bind(this),
    })
  },
})

var input_number = new Class({
  Extends: input,
  options: {
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  gather: function (breaks) {
    if (breaks) {
      var a = this.input.get('value').replace(/\n/g, '<br/>').clean(),
        meta = this.data.meta,
        format = '0'
      if (meta && meta.need_trailing_zeroes) {
        format = format + '.00'
      }
      if (meta && meta.need_thousand_seperator) {
        format = '0,' + format
      }
      if (this.data.is_required === false && !a) {
        return a
      }
      a = numeral(parseFloat(a)).format(format)
      if (meta && meta.value_type) {
        a = this.formatByType(a)
      }
      return a
    }
    return this.input.get('value').clean()
  },
  formatByType: function (value) {
    var vt = this.data.meta.value_type

    return vt === '%' ? value + '%' : vt + value
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (this.options.disallowed.indexOf(e.key) >= 0) {
          e.preventDefault()
          return
        }
        var eventKey = e.event.key
        if (
          (e.shift && e.key.toString().length > 1) ||
          (e.key.toString().test(/\D/i) && this.options.exceptions.indexOf(e.key.toString()) < 0)
        ) {
          if (
            eventKey == ',' ||
            eventKey == '.' ||
            (e.shift && e.key.toString() == 'left') ||
            (e.shift && e.key.toString() == 'right')
          ) {
            return
          }
          e.preventDefault()
          return
        }
        if (e.key.toString() == 'up' || e.key.toString() == 'down') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
        if (e.key.toString() == 'up') {
          var val = this.input.get('value').toFloat()
          val += e.shift ? 10 : 1
          this.input.set('value', val)
        }
        if (e.key.toString() == 'down') {
          var val = this.input.get('value').toFloat()
          val -= e.shift ? 10 : 1
          this.input.set('value', val)
        }
      }.bind(this),
    })
  },
})

var input_phone = new Class({
  Extends: input,
  options: {
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    var validators = this.validators()
    validators.minLength()
    validators.maxLength()

    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
      }.bind(this),
    })
  },
})

var input_email = new Class({
  Extends: input,
  options: {
    maxLength: 50,
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
        if (this.input.get('value').length > this.options.maxLength) {
          this.input.set('value', this.input.get('value').substr(0, this.options.maxLength))
        }
      }.bind(this),
    })
  },
})

var input_email = new Class({
  Extends: input,
  options: {
    maxLength: 50,
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
        if (this.input.get('value').length > this.options.maxLength) {
          this.input.set('value', this.input.get('value').substr(0, this.options.maxLength))
        }
      }.bind(this),
    })
  },
})

var input_iban = new Class({
  Extends: input,
  options: {
    maxLength: 34,
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
        if (this.input.get('value').length > this.options.maxLength) {
          this.input.set('value', this.input.get('value').substr(0, this.options.maxLength))
        }
      }.bind(this),
    })
  },
})

var input_time = new Class({
  Extends: input,
  options: {
    maxLength: 34,
    exceptions: ['backspace', 'up', 'down', 'left', 'right'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
      }.bind(this),
    })
  },
})

var input_nickname = new Class({
  Extends: input,
  options: {
    maxLengh: 25,
    exceptions: ['backspace', 'up', 'down', 'left', 'right', 'enter'],
    disallowed: ['space'],
  },
  inputEvents: function () {
    var validators = this.validators()

    validators.minLength()
    var maxLengh =
      parseInt(this.data.meta.maxChars, 10) || parseInt(this.data.meta.max_length, 10) || this.options.maxLengh
    validators.maxLength(maxLengh)

    this.element.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          this.send()
          return
        }
        if (
          this.options.disallowed.indexOf(e.key.toString()) > -1 ||
          (this.options.exceptions.indexOf(e.key.toString()) < 0 && !this.check(e.key.toString()))
        ) {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (
          this.options.disallowed.indexOf(e.key.toString()) > -1 ||
          (this.options.exceptions.indexOf(e.key.toString()) < 0 && !this.check(e.key.toString()))
        ) {
          e.preventDefault()
          return
        }
      }.bind(this),
    })
  },
})

var input_name = new Class({
  Extends: input,
  options: {
    maxLengh: 100,
    exceptions: ['backspace', 'up', 'down', 'left', 'right', 'enter'],
    disallowed: ['enter'],
  },
  inputEvents: function () {
    this.input.addEvents({
      keydown: function (e) {
        if (e.key.toString() == 'enter') {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function (e) {
        if (this.options.disallowed.indexOf(e.key.toString()) >= 0) {
          if (e.key.toString() == 'enter') {
            this.send()
          }
          e.preventDefault()
          return
        }
        if (this.input.get('value').length > this.options.maxLength) {
          this.input.set('value', this.input.get('value').substr(0, this.options.maxLength))
        }
      }.bind(this),
    })
  },
})

var input_first_name = new Class({
  Extends: input_name,
  options: {
    maxLengh: 50,
    exceptions: ['backspace', 'up', 'down', 'left', 'right', 'enter'],
    disallowed: ['enter'],
  },
})

var input_last_name = new Class({
  Extends: input_name,
  options: {
    maxLengh: 50,
    exceptions: ['backspace', 'up', 'down', 'left', 'right', 'enter'],
    disallowed: ['enter'],
  },
})

var input_password = new Class({
  Extends: input_short,
  gather: function (breaks) {
    if (breaks) {
      return '**********'
    }
    return this.input.get('value').clean()
  },
})

var PanelText = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="input--wrapper isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="input--error">' +
      '        <div class="error--avatar"></div>' +
      '        <div id="error-{{ eid }}" class="error--content"></div>' +
      '    </div>' +
      '    <div class="input--inner">' +
      '        <div class="bot--loading">' +
      '             <div class="loading--dots">' +
      '                 <div class="dot dot--a"></div>' +
      '                 <div class="dot dot--b"></div>' +
      '                 <div class="dot dot--c"></div>' +
      '             </div>' +
      '        </div>' +
      '        <div class="input--content">' +
      '            {% input %}' +
      '        </div>' +
      '        <button type="submit" class="input--button"></button>' +
      '    </div>' +
      '</div>'

    var shorttext =
      '<textarea aria-label="{{ title }}" autocomplete="off" class="data--wrapper" placeholder="{{ placeholder }}" rows="1" aria-describedBy="error-{{ eid }}">{% value %}</textarea>'
    var longtext =
      '<textarea aria-label="{{ title }}" autocomplete="off" class="data--wrapper" placeholder="{{ placeholder }}" rows="1" aria-describedBy="error-{{ eid }}">{% value %}</textarea>'
    var email =
      '<input aria-label="{{ title }}" autocomplete="nope" type="email" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var phone =
      '<input aria-label="{{ title }}" autocomplete="off" type="tel" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var number =
      '<input aria-label="{{ title }}" autocomplete="off" type="number" inputmode="decimal" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var iban =
      '<input aria-label="{{ title }}" autocomplete="off" type="text" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var name =
      '<input aria-label="{{ title }}" autocomplete="off" type="text" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var password =
      '<input aria-label="{{ title }}" autocomplete="nope" type="password" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'
    var time =
      '<input aria-label="{{ title }}" autocomplete="nope" type="time" pattern="[0-9]{2}:[0-9]{2}" min="{{minTime}}" max="{{maxTime}}" step="{{stepSize}}" lang="{{language}}" placeholder="{{ placeholder }}" class="data--wrapper" value="{% value %}" aria-describedBy="error-{{ eid }}"/>'

    return {
      base: base,
      shorttext: shorttext,
      longtext: longtext,
      number: number,
      time: time,
      email: email,
      phone: phone,
      iban: iban,
      name: name,
      first_name: name,
      last_name: name,
      nickname: shorttext,
      password: password,
    }
  },
  populate: function () {
    this.populateAnswer(
      function (value) {
        this.data.placeholder = value
        var base = this.template().base
        base = base.replace(/\{%\s*input\s*%\}+/g, this.template()[this.data.type.name])
        Object.each(
          this.data,
          function (val, key) {
            base = base.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), val)
          }.bind(this)
        )
        this.populateAnswer(
          function (base) {
            var objValue = []
            if (this.data.meta && this.data.meta.default) {
              this.populateAnswer(
                function (value) {
                  objValue.push(value)
                  base = base.replace(/\{% value %\}/g, value || '')
                  this.addToDom(base)
                }.bind(this),
                this.data.meta.default
              )
            } else {
              $$('.answer--bubble.by--user.redoTarget').each(
                function (answer, i) {
                  if (answer.get('family').toInt() == this.data.key) {
                    objValue.push(
                      answer
                        .getElements('.answer--body.update')[0]
                        .get('html')
                        .clean()
                        .replace(/\<br\>/gi, '\n')
                    )
                    answer.removeClass('redoTarget')
                  }
                }.bind(this)
              )
              base = base.replace(/\{% value %\}/g, objValue.getLast() || '')
              this.addToDom(base)
            }
          }.bind(this),
          base
        )
      }.bind(this),
      this.data.placeholder
    )
  },
  // addToDom: function(newElement){
  //     if(newElement){
  //         this.inputContainer.set("html", newElement);

  //         this.in();
  //         return;
  //     }
  //     this.populate()
  // },
  attach: function (renderOnly) {
    if (renderOnly) {
      this.element = $(this.data.eid)
    }

    this.input = this.element.getElements('.data--wrapper')[0]
    this.error = this.element.getElements('.error--content')[0]

    switch (this.data.type.name) {
      case 'shorttext':
        new input_short(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'longtext':
        new input_long(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'number':
        new input_number(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'email':
        new input_email(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'phone':
        new input_phone(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'iban':
        new input_iban(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'nickname':
        new input_nickname(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'time':
        new input_time(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'name':
        new input_name(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'first_name':
        new input_first_name(
          this.data,
          this.input,
          this.answerCallback,
          this.errorCallback,
          this.validateAnswerCallback
        )
        break
      case 'last_name':
        new input_last_name(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
      case 'password':
        new input_password(this.data, this.input, this.answerCallback, this.errorCallback, this.validateAnswerCallback)
        break
    }

    // error handling;
    this.element.addEvents({
      showError: function (msg) {
        var timeout = this.element.hasClass('hasError') ? 300 : 0
        this.element.removeClass('hasError')
        this.input.set('aria-invalid', false)
        setTimeout(
          function () {
            this.element.addClass('hasError')
            this.input.set('aria-invalid', true)
            this.error.set('html', msg.str)
          }.bind(this),
          timeout
        )
      }.bind(this),
    })
  },
})
